export const emailAccountsKeys = {
	all: ['emailAccounts'],
	lists: () => [...emailAccountsKeys.all, 'list'],
	list: (filters) => [...emailAccountsKeys.lists(), { filters }],
	details: () => [...emailAccountsKeys.all, 'detail'],
	detail: (id) => [...emailAccountsKeys.details(), id],
};

export const emailAccountsMutationKeys = {
	create: ['emailAccounts', 'create'],
	update: ['emailAccounts', 'update'],
	delete: ['emailAccounts', 'delete'],
	testConnection: ['emailAccounts', 'testConnection'],
};
